import { ChangeDetectionStrategy, Component, HostBinding } from '@angular/core';
import { AuthSecureRouteDialogComponent } from '@rd/core/components/auth-secure-route-dialog/auth-secure-route-dialog.component';
import { GuardhouseService } from '@rd/core/services/guardhouse/guardhouse.service';
import { IconRegistryService } from '@rd/core/services/icon-registry/icon-registry.service';
import { DialogRef } from '@rd/popup/dialog-ref';
import { PopupSettingService } from '@rd/popup/services/popup-setting/popup-setting.service';

@Component({
  selector: 'star-core-auth-secure-route-dialog',
  templateUrl: './auth-secure-route-dialog.component.html',
  styleUrls: [
    `../../../../../../../libs/core/src/lib/components/auth-secure-route-dialog/auth-secure-route-dialog.component.scss`,
    `./auth-secure-route-dialog.component.scss`,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class StarAuthSecureRouteDialogComponent extends AuthSecureRouteDialogComponent {
  @HostBinding('class.star-core-auth-secure-route-dialog')
  componentClass = true;

  constructor(
    dialogRef: DialogRef,
    iconRegistryService: IconRegistryService,
    popupSettingService: PopupSettingService,
    private guardhouseService: GuardhouseService,
  ) {
    super(dialogRef, iconRegistryService, popupSettingService);
  }

  redirectToLoginUrl(): void {
    this.guardhouseService.redirectToLoginUrl();
  }

  redirectToEnrollUrl(): void {
    this.guardhouseService.redirectToEnrollUrl();
  }
}
